import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { get_exports } from "./get/index.js";
//#region src/central/v2/users/index.ts
var users_exports = /* @__PURE__ */ __exportAll({ Get: () => get_exports });
//#endregion
export { users_exports };

//# sourceMappingURL=index.js.map